/*============================================================================
  DiamondBoss: bring the header cart drawer into view when it opens
  ----------------------------------------------------------------------------
  The header is not sticky, so the cart drawer (which drops down from the
  header) opens at the top of the page. After "Add to cart" further down a
  product page, especially on mobile, the shopper would otherwise see nothing
  happen. When the drawer becomes active and its top is off-screen, scroll up.
==============================================================================*/
;(function () {
  function watch(drawer) {
    new MutationObserver(function () {
      if (!drawer.classList.contains('is-active')) return
      if (drawer.getBoundingClientRect().top < 0) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] })
  }

  function init() {
    document.querySelectorAll('.site-header__cart').forEach(watch)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
